import { getMemberId, loadMembers } from './api';

/* The partner's name, for copy rendered in the PAIRED state (card DfhelObKj9iP,
   Jonathan 2026-10-30: "named in direct UI, generic partner in docs").

   The sweep this replaces was 90-odd strings, and the reason it was never a
   find-and-replace is in the other half of his sentence: pre-pair copy — the
   invite screen, the waiting states, the invite email, the legal and help text
   — has no partner to name yet, and "Waiting for Nina" before you have met her
   is worse than the generic phrase. So the rule is: a surface that already
   knows the pair names her; everything else keeps its words.

   Reads the members cache the app already syncs (lib/api.ts), so nothing new
   is fetched and the label is available on first paint. Returns the fallback
   untouched when there is no second member — call sites pass the sentence-form
   phrase they already used, so an unpaired device reads exactly as before. */

export function partnerName(fallback: string | null = null): string | null {
  const me = getMemberId();
  const other = loadMembers().find(m => m.memberId !== me);
  const name = other?.displayName?.trim();
  return name ? name : fallback;
}

/** "Nina", or the given phrase ("your partner") when the pair is not known. */
export function partnerLabel(fallback = 'your partner'): string {
  return partnerName(fallback) ?? fallback;
}

/** "Nina’s", or "your partner’s" — the possessive the copy actually needs.
 *  Apostrophe is the typographic one, matching the rest of the UI's inner
 *  punctuation. */
export function partnerPossessive(fallback = 'your partner’s'): string {
  const name = partnerName();
  return name ? `${name}’s` : fallback;
}

/** Capitalised form for a string that starts a sentence or a label. */
export function PartnerLabel(fallback = 'Your partner'): string {
  return partnerName(fallback) ?? fallback;
}
